export default __webpack_public_path__ + "static/media/home-hand.575c23eb.png";